import { render, staticRenderFns } from "./SubGlItemList.vue?vue&type=template&id=330dec7d&scoped=true"
import script from "./SubGlItemList.vue?vue&type=script&lang=js"
export * from "./SubGlItemList.vue?vue&type=script&lang=js"
import style0 from "./SubGlItemList.vue?vue&type=style&index=0&id=330dec7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330dec7d",
  null
  
)

export default component.exports